import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=c5374856&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5374856')) {
      api.createRecord('c5374856', component.options)
    } else {
      api.reload('c5374856', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=c5374856&", function () {
      api.rerender('c5374856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-266f0a6sxG7Ze/JS/comp/FavElement.vue"
export default component.exports